<template>
    <div>
        <h1>Help</h1>
    </div>
</template>

<script>
    export default {
        name: 'help-index',
    };
</script>

<style scoped>

</style>
